<template>
  <div>
    <slot name="target" :show="() => active = true"></slot>
    <ModalView v-model:active="active">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("warn") }}</h3>
          <ModalCloseButtonView @click="active = false"/>
        </div>
      </template>
      <template v-slot:body>
        <WarningFormView :community-id="communityId" :player-id="playerId" @success="active = false; emit('success')" @cancel="active = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ModalView, ModalCloseButtonView} from "@/niftybit";
import WarningFormView from "@/systems/modules/punishments/warnings/WarningFormView.vue";
import {ref} from "vue";

defineProps({
  communityId: String,
  playerId: String
});

const emit = defineEmits(["success"]);

const active = ref(false);

</script>